<template>
  <div 
    :class="[
     'grid grid-cols-3 cursor-pointer payment-container py-3', 
      { 'selected-payment-container-style': isSelect },
      { 'cursor-not-allowed': isDisabled }
    ]"
  >
    <div class="col-span-2 flex items-center justify-start pl-4">
      <span v-if="!isDisabled" :class="['material-icons ml-3.5', { 'checked-radio-btn-color': isSelect }]">
        {{ isSelect ? 'radio_button_checked' : 'radio_button_unchecked' }}
      </span>
      <div v-if="hasIconBackground" :class="['icon-bg-container', isDisabled ? 'ml-14' : 'ml-3.5']">
        <img :src="logoSrc" alt="card logo" class="icon-img-small" />
      </div>
      <img v-else :src="logoSrc" alt="card logo" :class="['logo', isDisabled ? 'ml-14' : 'ml-3.5']">
      <p class="ml-6 card">{{ accountNumber }}</p>
      <div v-if="isClinic" class="clinic-tag">
        <img src="@/assets/orderTest/clinic_card_label.svg" class="clinic-label">
        PRACTICE
      </div>
    </div>
    <div class="flex items-center justify-end gap-3 pr-2 min-w-0">
      <div>
        <p v-show="expireDate" :class="['card expire-date', { 'invalid': isExpired }]">Expires: {{ formatExp }}</p>
      </div>      
      <div :class="['mr-9 flex item-center justify-between']">
        <div v-if="isSelect && isShowEdit" @click.stop>
          <NewLibraryButton color-type="none-stroke" @click="$emit('edit')">
            Edit
          </NewLibraryButton>
        </div>
        <div v-if="isSelect && isShowDelete" @click.stop>
          <NewLibraryButton color-type="none-stroke" @click="$emit('remove')">
            Remove
          </NewLibraryButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewLibraryButton from "@/NewLibrary/Button.vue";

export default {
  components: { NewLibraryButton },
  props: {
    isSelect: {
      type: Boolean,
      default: false
    },
    logoSrc: {
      type: String,
      default: ""
    },
    accountNumber: {
      type: String,
      default: "**** **** **** 1111"
    },
    isClinic: {
      type: Boolean,
      default: false
    },
    expireDate: {
      type: String,
      default: ""
    },
    isShowEdit: {
      type: Boolean,
      default: true
    },
    isShowDelete: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    hasIconBackground: {
      type: Boolean,
      default: false
    }
  },
  emits: ["edit", "remove"],
  data() {
    return {
      currentYear: new Date().getFullYear().toString(),
      currentMonth: (new Date().getMonth() + 1).toString().length === 1
        ? "0" + (new Date().getMonth() + 1)
        : (new Date().getMonth() + 1).toString(),
    }
  },
  computed: {
    isExpired() {
      // backend return format: MMYYYY
      // may return format: MYYYY for month 1-9
      // so handle both cases
      let accountExpYear = this.expireDate.slice(-4);
      let accountExpMonth = this.expireDate.length < 6 ? "0" + this.expireDate[0] : this.expireDate.slice(0, 2);
      return accountExpYear < this.currentYear 
        || (accountExpMonth < this.currentMonth && accountExpYear === this.currentYear);
    },
    formatExp() {
      let accountExpYear = this.expireDate.slice(-4);
      let accountExpMonth = this.expireDate.length < 6 ? "0" + this.expireDate[0] : this.expireDate.slice(0, 2);
      return accountExpMonth + "/" + accountExpYear;
    }
  }
}
</script>

<style scoped>

.payment-container {
  height: 72px;
  border: 1px solid #c4c4c4;
  border-radius: 3px;
  background: #FFF;
  color: rgba(0,0,0,0.26);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}
.selected-payment-container-style {
  border: 1px solid #004879;
  background-color: #F9FBFD;
}

.checked-radio-btn-color {
  color: #004879;
}

.clinic-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  margin-left: 12px;
  min-width: 76px;
  height: 26px;
  background: linear-gradient(0deg, #B4E5EA, #B4E5EA), #000000;
  border-radius: 20px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.4004px;

  color: #000000;
}

.logo {
  width: 50px;
}

.icon-bg-container {
  width: 40px;
  height: 40px;
  background: #EEF3F7;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-img-small {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.clinic-label{
  width: 14px;
  height: 9px;
}

.card {
  color: rgba(0,0,0,1);
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0.46px;
}

.expire-date {
  font-size: 14px;
  line-height: 16px;
}

.invalid {
  color: red;
}

.edit.el-button, .edit.el-button:active, .edit.el-button:hover {
  color: rgba(54,171,191,1);
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0.4px;
  padding: 0;
  border: none;
  background: transparent;
}

.remove.el-button, .remove.el-button:active, .remove.el-button:hover {
  color: #20A8C3;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0.4px;
  padding: 0;
  border: none;
  background: transparent;
}
</style>